import { Button, Form, Input, Space } from 'antd';
import { FC } from 'react';

import { ButtonSuccess } from '../../../../../common/components';
import { AppFormProps } from '../../../../../common/interfaces';
import { defineInputStatus } from '../../../../../common/utils';
import { HostingFormInputs, HostingsFormFields } from '../../../hostings.interfaces';

interface Props extends AppFormProps<typeof HostingFormInputs, HostingsFormFields> {}

export const HostingsFormView: FC<Props> = ({
  formName,
  formType,
  form,
  initialValues,
  formErrors,
  isFormLoading,
  validationSchema,
  handleBack,
  handleFinish,
  handleFinishFailed
}) => {
  return (
    <Form
      form={ form }
      layout="vertical"
      name={ formName }
      initialValues={ initialValues }
      disabled={ isFormLoading }
      autoComplete="off"
      onFinish={ handleFinish }
      onFinishFailed={ handleFinishFailed }
    >
      <Form.Item
        label="Назва"
        name={ HostingFormInputs.Name }
        hasFeedback
        help={ formErrors?.name }
        validateStatus={ defineInputStatus(isFormLoading, formErrors?.name) }
        rules={ validationSchema.name }
      >
        <Input allowClear/>
      </Form.Item>

      <Form.Item
        label="Посилання"
        name={ HostingFormInputs.Link }
        hasFeedback
        help={ formErrors?.link }
        validateStatus={ defineInputStatus(isFormLoading, formErrors?.link) }
        rules={ validationSchema.link }
      >
        <Input allowClear/>
      </Form.Item>

      <Form.Item wrapperCol={{ span: 24 }}>
        <Space align="center" style={{ width: '100%', justifyContent: 'flex-end' }}>
          <Button type="default" onClick={ handleBack }>
            Скасувати
          </Button>
          <ButtonSuccess loading={ isFormLoading } type="primary" htmlType="submit">
            { formType === 'edit' ? 'Зберегти' : 'Створити' }
          </ButtonSuccess>
        </Space>
      </Form.Item>
    </Form>
  );
};
